export default "__VITE_ASSET__B5XIZFqO__"